import { Box, Typography, TextField, Stack, Button, useTheme, IconButton } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import route from '../../../utils/Routes';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { editProdAllInfoServ, editProductServ, getSingleProdServ } from '../../../services/amtc-service';
import { isNotEmpty } from '../../../utils/format';
import { customAlert, notify } from '../../../components/notify';
import BgBoxOld from '../../../components/BgBoxOld';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import UploadSection from '../AddNewProductPage/UploadSection';
import AttachSection from '../AddNewProductPage/AttachSection';


function EditProductInfoPg({ type = "normal" }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { prodId } = location.state || {};
    const { setLoadingScreen } = useAuthContext();
    const [formErrors, setFormErrors] = useState({});
    const [imgs, setImgs] = useState([]);
    const [specs, setSpecs] = useState([]);
    const [attchs, setAttchs] = useState([]);
    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.amtcProdInfo, prodId, "amtc"], () => getSingleProdServ(prodId, "amtc"),
        {
            enabled: isNotEmpty(prodId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })

    const conditionFields = type === "all" ? {} : { bgColor: "rgba(162, 214, 249, 0.18)", readOnly: true }




    useEffect(() => {
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!prodId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prodId])

    useEffect(() => {
        if (!prodData)
            return

        setData(prodData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prodData])

    function setData(data) {
        //({ fileKey, fileUrl: imgUrl }) img
        //{ fileKey, fileUrl: imgUrl, fileName: file.name }) attch
        //  { catSpec: "",value: ""}
        const imgArr = (data?.prodImgs || []).map((i) => ({ fileKey: i.prodImage, fileUrl: i.fileUrl }));
        setImgs(imgArr)
        const attchArr = (data?.prodFiles || []).map((i) => ({ fileKey: i.attachFile, fileUrl: i.fileUrl, fileName: i.fileName }));
        setAttchs(attchArr)
        setSpecs(data?.prodSpecsJs || [])
    }


    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                prodName: inputObject.prodName,
                prodDesc: inputObject.prodDesc,
                mfrName: inputObject.mfrName,
                prodSpecsArr: [...specs],
                imgsArr: imgs.map((i) => ({ prodImage: i.fileKey })),
                attachFilesArr: attchs.map((i) => ({ attachFile: i.fileKey, fileName: i.fileName }))
            }

            if (type === "all") {
                const updatedPayload = {
                    ...payload,
                    prodIdNum: prodData?.id,
                    amtcProdIdStrg: inputObject.amtcProdIdStrg,
                    oldAmtcProdIdStrg: prodId,
                    avlQty: isNotEmpty(inputObject.avlQty) ? inputObject.avlQty : 0,
                    amtcPrice: isNotEmpty(inputObject.amtcPrice) ? inputObject.amtcPrice : 0,
                    amtcTax: isNotEmpty(inputObject.amtcTax) ? inputObject.amtcTax : 0,
                };
                const { message } = await editProdAllInfoServ(updatedPayload);
                notify("success", message);
                navigate(`${route.aApprCreatedProdInfo}/?prodId=${inputObject.amtcProdIdStrg}`, { replace: true });
            } else {
                const { message } = await editProductServ(payload, prodId);
                notify("success", message);
                navigate(`${route.aProduct}/?prodId=${prodId}`, { replace: true });
            }


        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    function validate(values) {
        const errors = {};

        if (!values.prodName)
            errors.prodName = "Product Name is required!";

        if (type === "all") {
            if (!values.amtcProdIdStrg)
                errors.amtcProdIdStrg = "AMTC Product ID is required!";
        }
        console.log(errors)
        return errors;
    };


    function handleImgRemove(index) {
        const updatedImages = imgs.filter((_, i) => i !== index);
        setImgs(updatedImages);
    };

    function handleOnUpload(uploadedFiles) {
        setImgs(prevImages => [...prevImages, ...uploadedFiles])
    }

    function handleFileRemove(index) {
        const updatedImages = attchs.filter((_, i) => i !== index);
        setAttchs(updatedImages);
    };

    function handleOnFileUpload(uploadedFiles) {
        setAttchs(prev => [...prev, ...uploadedFiles])
    }

    function handleCancel() {
        navigate(`${route.aProduct}/?prodId=${prodId}`, { replace: true });
    }

    function addSpecs() {
        setSpecs([
            ...specs,
            {
                catSpec: "",
                value: ""
            }
        ]);
    };

    function removeSpecs(index) {
        const updatedSpecs = [...specs];
        updatedSpecs.splice(index, 1);
        setSpecs(updatedSpecs);
    };

    const handleSpecsValChange = (index, e) => {
        const { name: field, value } = e.target;
        const updatedSpecs = [...specs];
        updatedSpecs[index][field] = value;
        setSpecs(updatedSpecs);
    };



    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
            <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
                <BackButton width={"33.3%"} />
                <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"33.3%"}>
                    <Typography width={"33.3%"} sx={{ fontSize: 18, fontWeight: 500 }}>Edit Product</Typography>
                </Stack>
                <Box width={"33.3%"} />
            </Stack>
            <BgBoxOld height={"93%"} py={1} px={0.1}>
                <ScrollBox height={"100%"} width={"100%"}>
                    {prodData && <Stack direction={"row"} height={"100%"} width={"100%"} gap={6} mt={1} px={2}>
                        <Box sx={{ width: '30%', height: "100%" }}>
                            <UploadSection imgArr={imgs} onUpload={handleOnUpload} onRemove={handleImgRemove} />
                        </Box>
                        <Box sx={{ width: "65%" }} >
                            <Stack sx={{ gap: 1 }}>
                                <Stack direction={"row"} alignItems={"center"} gap={10}>
                                    <LabelTxtFieldInfo defaultValue={prodData?.prodName} name="prodName" title="Product Name *" errMsg={formErrors.prodName} width={300} height={25} borderRadius={1} />
                                    <LabelTxtFieldInfo defaultValue={prodData?.amtcProdIdStrg} {...conditionFields} errMsg={type === "all" ? formErrors.prodName : null}
                                        name="amtcProdIdStrg" title="Amtc Product ID *" width={300} height={25} borderRadius={1} />
                                </Stack>
                                <Stack direction={"row"} alignItems={"center"} gap={10}>
                                    <LabelTxtFieldInfo readOnly={true} name="Category" title="Category" width={300} height={25} borderRadius={1}
                                        defaultValue={prodData?.parCatName} bgColor={"rgba(162, 214, 249, 0.18)"} />
                                    <LabelTxtFieldInfo readOnly={true} name="Sub-Category" title="Sub-Category" width={300} height={25} borderRadius={1}
                                        defaultValue={prodData?.subCatName} bgColor={"rgba(162, 214, 249, 0.18)"} />
                                </Stack>
                            </Stack>
                            <Typography sx={{ mt: 2, mb: 1, fontsize: 13, fontWeight: "600" }}>Product Pricing Details</Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography fontSize={12} sx={{ color: "rgba(0, 0, 0, 0.8)" }}>
                                        Product Quantity <Typography fontSize={10} component="span" variant="caption" >(Nos)</Typography>
                                    </Typography>
                                    <TextField defaultValue={prodData?.avlQty} name='avlQty' type='number' size='small' InputProps={{ readOnly: type === "all" ? false : true }}
                                        sx={{ '& .MuiOutlinedInput-root': { fontSize: 11, width: 110, color: "rgba(0, 0, 0, 1)", bgcolor: type === "normal" && "rgba(162, 214, 249, 0.18)" } }} />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography fontSize={12} sx={{ color: "rgba(0, 0, 0, 0.8)" }}>
                                        Price <Typography component="span" fontSize={10} variant="caption">(OMR)</Typography>
                                    </Typography>
                                    <TextField defaultValue={prodData?.amtcPrice} name='amtcPrice' type='number' size='small' InputProps={{ readOnly: type === "all" ? false : true }}
                                        sx={{ '& .MuiOutlinedInput-root': { fontSize: 11, width: 110, color: "rgba(0, 0, 0, 1)", bgcolor: type === "normal" && "rgba(162, 214, 249, 0.18)" } }} />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography fontSize={12} sx={{ color: "rgba(0, 0, 0, 0.8)" }}>
                                        Tax <Typography component="span" fontSize={10} variant="caption">(in %)</Typography>
                                    </Typography>
                                    <TextField defaultValue={prodData?.amtcTax} name='amtcTax' type='number' size='small' InputProps={{ readOnly: type === "all" ? false : true }}
                                        sx={{ '& .MuiOutlinedInput-root': { fontSize: 11, width: 110, color: "rgba(0, 0, 0, 1)", bgcolor: type === "normal" && "rgba(162, 214, 249, 0.18)" } }} />
                                </Box>
                            </Box>
                            <Box sx={{ mt: 3 }}>
                                <Typography sx={{ mb: 0.5, fontsize: 13, fontWeight: "600" }}>About This Product</Typography>
                                <LabelTxtFieldInfo defaultValue={prodData?.prodDesc} labelwidth={"100%"} name="prodDesc" title="Product Description"
                                    width={"100%"} height={"80%"} fontSize={12} borderRadius={2} rows={5} multiline={true} />
                            </Box>
                            <Stack direction={"row"} mt={1} width={"100%"} justifyContent={"space-between"}>
                                <Box sx={{ width: '45%' }}>
                                    <Stack direction={'row'} alignItems='center' >
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "rgba(0, 0, 0, 0.8)" }}>Product Specification</Typography>
                                        <IconButton onClick={addSpecs}>
                                            <AddCircle sx={{ color: theme.palette.custom.btn }} />
                                        </IconButton>
                                    </Stack>
                                    <ScrollBox height={300} width={310}>
                                        {specs.map((i, index) => (
                                            <Stack direction={"row"} key={index} alignItems={"center"} >
                                                <Stack direction={"row"} alignItems={"center"} gap={1}>
                                                    <TextField defaultValue={i.catSpec} name='catSpec' size='small' onChange={(e) => handleSpecsValChange(index, e)}
                                                        sx={{ '& .MuiOutlinedInput-root': { fontSize: 12, width: 130 } }} />
                                                    <TextField defaultValue={i.value} name='value' size='small' onChange={(e) => handleSpecsValChange(index, e)}
                                                        sx={{ '& .MuiOutlinedInput-root': { fontSize: 12, width: 130 } }} />
                                                </Stack>
                                                <IconButton onClick={() => removeSpecs(index)}>
                                                    <RemoveCircle sx={{ color: "red" }} />
                                                </IconButton>
                                            </Stack>
                                        ))}
                                    </ScrollBox>
                                </Box>
                                <Box sx={{ width: '55%', mb: 3 }}>
                                    <LabelTxtFieldInfo defaultValue={prodData?.mfrName} name="mfrName" title="Manufacturer" width={300} height={25} borderRadius={1} />
                                    <AttachSection filesArr={attchs} onUpload={handleOnFileUpload} onRemove={handleFileRemove} />
                                </Box>
                            </Stack>
                            <Stack direction={"row"} alignItems={"center"} sx={{ width: "100%", justifyContent: "end" }} >
                                <Button variant="outlined" onClick={handleCancel} sx={{
                                    fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                                    color: theme.palette.custom.btn, mr: 2,
                                }}>CANCEL</Button>
                                <Button variant="contained" type="submit"
                                    sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", mr: 10 }}>
                                    SAVE</Button>
                            </Stack>
                        </Box>


                    </Stack>}
                </ScrollBox>
            </BgBoxOld>
        </form>
    );
}
export default EditProductInfoPg